import { createContext } from 'react';
export var NotificationsContext = createContext({
    deleteNotification: function () { },
    toggleViewed: function () { },
});
